<template>
  <v-container  class="h-100 " >
    <v-row no-gutters class="h-100">
      <v-col class="h-100" style="overflow-y: scroll">
      <v-data-table
              :headers="fields"
              :items-per-page="Items.length"
              :items="Items"
              item-key="id"
              no-data-text="Нет элементов"
              no-results-text="Не найдено"
              loading-text="Загрузка данных"
              calculate-widths
              class="elevation-1"
              :search="search"
              fixed-header
              sort-by="requestDateTime"
              sort-desc
              hide-default-footer
              @click:row="showDetailModal"
      >
        <template v-slot:item.isRead="{ item }">
          <div v-if="item.isRead==false" class="markNotRead"></div>
        </template>
        <template v-slot:item.requestNumber="{ item }">
          <span :class="{'readRow':item.isRead}"> {{item.requestNumber}}</span>
        </template>
        <template v-slot:item.carName="{ item }">
          <span :class="{'readRow':item.isRead}"> {{ item.carMarkName+' '+item.carModelName +', '+ item.carYear}}</span>
        </template>

        <template v-slot:item.requestDateTime="{ item }">
          <span :class="{'readRow':item.isRead}"> {{ formatTimeDateMounthName(item.requestDateTime) }}</span>
        </template>
        <template v-slot:item.clientFullName="{ item }">
          <span :class="{'readRow':item.isRead}"> {{ item.clientFullName }}</span>
        </template>
        <template v-slot:item.requestCategoryName="{ item }">
          <span :class="{'readRow':item.isRead}"> {{ item.requestCategoryName }}</span>
        </template>

      </v-data-table>
      </v-col>
    </v-row>
    <detailsModal isArchive :show="showDetail" :detailedItem="detailedItem" @close="closeDetails"></detailsModal>

  </v-container>

</template>

<script>

    const detailsModal =()=> import('./DetailsRequest.vue')
    export default {
        components:{detailsModal},
        props:{
            search:String
        },
        name: "NewRequests",
        data() {
            return {
                selected: null,
                fields: [
                    {text: '№', value: 'requestNumber', width: "60px"},
                    {text: 'Создана', value: 'requestDateTime',width: "170px"},
                    {text: 'S', value: 'isRead', filterable: false, width: "60px", align: "center"},
                    {text: 'Клиент', value: 'clientFullName',width: "300px"},
                    {text: 'Транспортное средство', value: 'carName', width: "230px"},
                    {text: 'Категория заявки', value: 'requestCategoryName'},
                    {text: 'Тема обращения', value: 'serviceType'},
                ],
                showDetail:false,
                detailedItem:null,
            }
        },
        computed:{

            Items() {
                var items = this.$store.state.Requests.archiveRequests;
                if (items != null) {
                    return items
                }
                else return [];
            },

        },
        created(){
            this.$store.dispatch("Requests/getAchiveRequests")
                .catch(err=>{
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки списка архивных заявок!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })

        },
        methods:{

            closeDetails(){
                this.showDetail=false
            },

            showDetailModal(e){
                this.detailedItem=e;
                this.showDetail=true;
            },
        }
    }
</script>

<style scoped>
  .rowTop{
    position: absolute;
    top:-50px;
  }
</style>
